import {
  ActivityType,
  EmploymentType,
  FlatRateTax,
  PersonalKeyGroup,
} from 'modules/contracts/hooks/useFetchGermanContractData'

export const getActivityType = (
  activityTypes: ActivityType[],
  activityTypeId?: string
): ActivityType | undefined => {
  return activityTypes.find(({ value }) => value === activityTypeId)
}

export const getEmploymentType = (
  employmentTypes: EmploymentType[],
  employmentTypeId?: string
): EmploymentType | undefined => {
  return employmentTypes.find(({ value }) => value === employmentTypeId)
}

export const getFlatRateTax = (
  flatRateTaxes: FlatRateTax[],
  flatRateTaxId?: string
): FlatRateTax | undefined => {
  return flatRateTaxes.find(({ value }) => value === flatRateTaxId)
}

export const getPersonalKeyGroup = (
  personalKeyGroups: PersonalKeyGroup[],
  personalKeyGroupId?: string
): PersonalKeyGroup | undefined => {
  return personalKeyGroups.find(({ value }) => value === personalKeyGroupId)
}
